export default __webpack_public_path__ + "static/media/miguel-lopes-26.23d01f9d.jpg";